import React, {Component} from "react";
import {Route } from "react-router-dom";
import {
    NavLink
} from 'reactstrap'

import styles from './HeaderLink.css'

export default class HeaderLink extends Component {
    render() {

        const {label, to, activeOnlyWhenExact, onClick, noActive} = this.props;

        return (
            <Route
                path={to}
                exact={activeOnlyWhenExact}
                children={({ match }) => (
                    <div className={[styles.linkWrapper, (match && !noActive) ? styles.active : ""].join(' ')}>
                        <NavLink href={to} onClick={onClick} className={[(match && !noActive) ? "active" : "", styles.navLink].join(' ')}>{label}</NavLink>
                    </div>
                )}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/HeaderLink/HeaderLink.js